/*
 * @Author: AI Assistant
 * @Date: 2024-12-30 16:00:00
 * @LastEditors: AI Assistant
 * @LastEditTime: 2024-12-30 16:00:00
 * @FilePath: /RetailApp/retail-global-h5/src/pages/CPS/components/OrderCard.tsx
 * @Description: 订单卡片组件 - 根据Figma设计稿实现
 */
import { memo } from 'react';
import intl from 'react-intl-universal';
import { WaybillInfo, OrderStatus } from '../../../../api/retailGlobal/CPS';
import styles from './OrderCard.less';
import locationIcon from '../../../../assets/retailGlobal/CPS/location-icon.png';

interface OrderCardProps {
  order: WaybillInfo;
  onViewLogistics?: (orderItemId: string) => void;
}

function OrderCard({ order, onViewLogistics }: OrderCardProps) {
  const getOrderStatusText = () => {
    // 状态颜色配置
    const ORANGE_COLOR = '#FF8514';
    const GREEN_COLOR = '#1CB07F';
    
    // 优先使用 orderStatus 枚举来判断颜色和获取翻译文本
    if (order.orderStatus !== undefined && order.orderStatus !== null) {
      // 状态配置：文本和颜色
      const statusConfig: Record<OrderStatus, { textKey: string; color: string }> = {
        [OrderStatus.ALL_STATUS]: { textKey: 'cps.orderStatus.allStatus', color: ORANGE_COLOR },
        [OrderStatus.WAIT_FOR_PAY]: { textKey: 'cps.orderStatus.waitForPay', color: ORANGE_COLOR },
        [OrderStatus.PRE_PAID]: { textKey: 'cps.orderStatus.prePaid', color: ORANGE_COLOR },
        [OrderStatus.PAY_SUCCESS]: { textKey: 'cps.orderStatus.paySuccess', color: ORANGE_COLOR }, // 已付款 - 橙色
        [OrderStatus.PREPARED]: { textKey: 'cps.orderStatus.prepared', color: ORANGE_COLOR },
        [OrderStatus.DELIVERING_SUCCESS]: { textKey: 'cps.orderStatus.deliveringSuccess', color: ORANGE_COLOR }, // 已出库 - 橙色
        [OrderStatus.DELIVERED_SUCCESS]: { textKey: 'cps.orderStatus.deliveredSuccess', color: GREEN_COLOR }, // 已妥投 - 绿色
        [OrderStatus.REFUNDING]: { textKey: 'cps.orderStatus.refunding', color: ORANGE_COLOR }, // 退款中 - 橙色
        [OrderStatus.CLOSED_SUCCESS]: { textKey: 'cps.orderStatus.closedSuccess', color: GREEN_COLOR },
        [OrderStatus.CREATE_FAIL]: { textKey: 'cps.orderStatus.createFail', color: ORANGE_COLOR },
        [OrderStatus.REFUND_SUCCESS]: { textKey: 'cps.orderStatus.refundSuccess', color: GREEN_COLOR }, // 已退款 - 绿色
        [OrderStatus.PARTIAL_PAID]: { textKey: 'cps.orderStatus.partialPaid', color: ORANGE_COLOR },
      };
      
      const config = statusConfig[order.orderStatus];
      if (config) {
        const translatedText = intl.get(config.textKey);
        // 优先使用翻译文本，如果翻译不存在则使用 orderStatusDesc
        const displayText = translatedText || order.orderStatusDesc || '';
        if (displayText) {
          return { text: displayText, color: config.color };
        }
      }
    }
    
    // 如果枚举值不存在，回退使用 orderStatusDesc（仅显示文本，颜色使用默认橙色）
    if (order.orderStatusDesc) {
      return { text: order.orderStatusDesc, color: ORANGE_COLOR };
    }
    
    return { text: '', color: ORANGE_COLOR };
  };

  const statusInfo = getOrderStatusText();

  return (
    <>
      <div className={styles['logistics-status']}>
        <div 
          className={styles['status-text']}
          style={{ color: statusInfo.color }}
        >
          {statusInfo.text}
        </div>
      </div>
      <div className={styles['order-card']}>
        <div className={styles['order-number']}>{order.saOrderId}</div>
        <div className={styles['divider']}></div>
        <div className={styles['address-row']}>
          <img 
            src={locationIcon} 
            alt="location" 
            className={styles['location-icon']}
          />
          <div className={styles['address-text']}>{order.address}</div>
        </div>
        <div className={styles['products-section']}>
          {order.waybillItem?.map((item, itemIndex) => (
            <div key={itemIndex} className={styles['product-row']}>
              <div className={styles['product-image-wrapper']}>
                {item.imgUrl ? (
                  <img 
                    src={item.imgUrl} 
                    alt={item.goodsName}
                    className={styles['product-image']}
                  />
                ) : (
                  <div className={styles['product-image-placeholder']}></div>
                )}
              </div>
              <div className={styles['product-details']}>
                <div className={styles['product-name']}>{item.goodsName}</div>
                <div className={styles['product-quantity']}>x{item.goodsCount}</div>
              </div>
              {onViewLogistics && (
                <button 
                  className={styles['view-logistics-btn']}
                  onClick={() => onViewLogistics(item.orderItemId)}
                >
                  {intl.get('cps.viewLogistics') || 'View Logistics'}
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default memo(OrderCard);

